<!-- Responsibility: Render the system-controls content surface hosted inside the generic modal.
Scope: System-controls content only; modality is owned by modal. -->
<system-controls-dialog>
  <article class="system-controls-dialog">
    <header class="sc-header">
      <h2>SYSTEM CONTROLS</h2>
      <button class="close-btn modal-close-hit" aria-label="Close system controls" onclick={ closeNow }>X</button>
    </header>

    <section class="sc-body">
      <sys-panel></sys-panel>
    </section>
  </article>

  <script>
    import SysPanel from '../../panels/sys-panel.riot'

    export default {
      components: { SysPanel },

      async closeNow() {
        await this.props.requestModalClose?.('close-button')
      },
    }
  </script>

  <style>
    system-controls-dialog {
      display: block;
      min-width: min(92vw, 58rem);
    }

    .system-controls-dialog {
      display: flex;
      flex-direction: column;
      gap: var(--space-md);
      min-height: 0;
    }

    .sc-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: var(--space-md);
    }

    .sc-header h2 {
      margin: 0;
      letter-spacing: 0.12em;
    }

    .sc-body {
      overflow: auto;
      min-height: 0;
      padding-right: var(--space-xs);
    }
  </style>
</system-controls-dialog>
